export class WaitMinuteBeforeNextLogin extends Error {
  constructor() {
    super(`Wait a minute before next try`);
  }
}
